import _ from 'lodash';
import moment from 'moment';
// import { SCHEMA_CONSTANTS } from '../components/assetManagement/AssetManagementForm/schemaConstants';
/* eslint-disable guard-for-in */

export function convertavailabilityTocertainTimeZone(availabilityList) {
  const availability = availabilityList;
  const returnObj = [];
  availability.forEach((availabilityObj) => {
    const { availabilityStartTime, availabilityStartDate, availabilityEndTime, availabilityEndDate } = availabilityObj;
    // const startDateTime = `${availabilityStartDate} ${availabilityStartTime}:00`;
    // const endDateTime = `${availabilityEndDate} ${availabilityEndTime}:00`;
    const availabilityStartTimeArr = availabilityStartTime.split(':');
    const availabilityEndTimeArr = availabilityEndTime.split(':');
    const startTime = moment({
      hours: availabilityStartTimeArr[0],
      minutes: availabilityStartTimeArr[1],
    }).toISOString();
    const startDate = moment(availabilityStartDate).startOf('day').toISOString();
    const endTime = moment({ hours: availabilityEndTimeArr[0], minutes: availabilityEndTimeArr[1] }).toISOString();
    const endDate = moment(availabilityEndDate).endOf('day').toISOString();
    returnObj.push({
      endDate,
      timeZone: 'America/Chicago',
      startTime,
      endTime,
      startDate,
    });
  });

  return returnObj;
}

export function bulkEditToSaveObj(selectedUsers, formvalue) {
  const obj = _.cloneDeep(selectedUsers);

  if (obj.areas && _.isArray(obj.areas)) {
    obj.areas.forEach((areaObj, index) => {
      const { areaName } = areaObj;

      if (areaName) {
        obj.areas[index] = _.omit(areaObj, 'areaName');
      }
    });
  }

  for (const [formKeys, formValues] of Object.entries(formvalue)) {
    if (formKeys === 'availability') {
      const availability = formValues.filter(
        (availabilityobj) =>
          availabilityobj.availabilityStartTime &&
          availabilityobj.availabilityStartDate &&
          availabilityobj.availabilityEndTime &&
          availabilityobj.availabilityEndDate
      );
      if (!_.isEmpty(availability)) {
        obj.availability = convertavailabilityTocertainTimeZone(availability, 'America/Chicago');
      }
    }
    if (formKeys === 'type') {
      if (!_.isEmpty(formValues)) obj.type = formValues;
    }
    if (formKeys === 'fieldId') {
      obj.fieldId = formValues;
    }
    if (formKeys === 'watcherList') {
      const tempWatcherObj = [];
      if (formValues && _.isArray(formValues) && !_.isEmpty(formValues)) {
        formValues.forEach((watchId) => {
          tempWatcherObj.push(watchId);
        });
        obj.staticList = tempWatcherObj;
      }
    }
    if (formKeys === 'stopId') {
      obj.stopId = formValues;
    }

    if (formKeys === 'customAttributeChange') {
      let tempObj = _.cloneDeep(obj.customAttributes);
      if (!_.isEmpty(formValues)) tempObj = { ...tempObj, ...formValues };
      obj.customAttributes = tempObj;
    }
    if (formKeys === 'attachmentList') {
      if (!_.isEmpty(formValues)) {
        obj.attachments = formValues;
        _.omit(obj, ['attachmentList']);
      }
    }
  }

  return obj;
}

export function checkForgolbalAttributeChanges(originalList, newList) {
  const returnObj = {};
  newList.forEach((customAttributeObject, index) => {
    if (customAttributeObject.defaultValue !== originalList[index].defaultValue) {
      const keyName = customAttributeObject.attributeDisplayName;
      const value = customAttributeObject.defaultValue;
      returnObj[keyName] = value;
    }
  });

  return returnObj;
}
